<template>
  <div>
    <!--  Summary
    -------------------------------------------------- -->
    <template v-if="isSummary">
      <div class="columns">
        <div class="column">
          <summary-item
            :amount="maxAllowableOffer"
          >Maximum<br>Allowed Offer</summary-item>
        </div>
        <div class="column">
          <summary-item
            :amount="record.projected_profit"
          >Projected<br>Profit</summary-item>
        </div>
      </div>

      <info-item
        label="Closed Date"
        :value="buyingInfo.buying_info_closing_at"
        is-date
      ></info-item>
    </template>

    <!-- Expanded
    -------------------------------------------------- -->
    <template v-else>
      <info-heading
        heading="Buying Analysis"
      >
        <div class="flex flex-centered">
          <button-icon
            icon="edit"
            color="is-secondary"
            @click="$refs.flipAnalysisModal.open(analysis)"
          ></button-icon>
        </div>
      </info-heading>

      <div v-if="analysis"> <!-- Need this div to allow css last-of-type to work -->
        <analysis-item label="After Repair Value" :value="analysis.after_repair_value"></analysis-item>
        <analysis-item label="Repair Costs" :value="analysis.repair_costs"></analysis-item>
        <analysis-item label="Holding Costs" :value="analysis.holding_costs" :time="analysis.holding_time"></analysis-item>
        <analysis-item label="Other Costs" :value="analysis.other_costs"></analysis-item>
        <analysis-item label="Desired Profit" :value="analysis.desired_profit"></analysis-item>
        <analysis-item label="Maximum Allowed Offer" :value="maxAllowableOffer" is-result></analysis-item>
      </div><hr>

      <profit-item
        type="Projected"
        :amount="record.projected_profit"
        hint="Project Profit = ARV - All Costs - Latest Buying Offer"
      ></profit-item>
      <hr>

      <!-- Dates -->
      <info-heading
        heading="Dates"
      >
        <button-icon
          icon="edit"
          color="is-secondary"
          @click="$refs.buyingInfoModal.open(buyingInfo)"
        ></button-icon>
      </info-heading>

      <info-item
        label="Accepted Date"
        :value="buyingInfo.buying_info_accepted_at"
        is-date
      ></info-item>
      <info-item
        label="Contract Date"
        :value="buyingInfo.buying_info_contracted_at"
        is-date
      ></info-item>
      <info-item
        label="Closed Date"
        :value="buyingInfo.buying_info_closing_at"
        is-date
      ></info-item>
    </template>

    <modal-container>
      <!-- Buying Info Modal -->
      <modal-crud-form
        ref="buyingInfoModal"
        title="Buying Info Dates"
        form-component="buying-info-form"
        hide-delete-button
        is-triple-column
      ></modal-crud-form>

      <!-- Analysis Modal -->
      <modal-crud-form
        ref="flipAnalysisModal"
        title="Analysis"
        form-component="flip-analysis-form"
        hide-delete-button
      ></modal-crud-form>
    </modal-container>
  </div>
</template>

<script>
import AnalysisItem from "./AnalysisItem";
import SummaryItem from "./SummaryItem";
import InfoHeading from "./InfoHeading";
import InfoItem from "./InfoItem";
import ProfitItem from "./ProfitItem";
import PropertyCompsModal from "../PropertyCompsModal.vue";

export default {
  name: "BuyingInfoFlipAnalysis",
  components: {PropertyCompsModal, ProfitItem, InfoItem, InfoHeading, SummaryItem, AnalysisItem},
  props: {
    isSummary: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    record() {
      return this.$store.state.activeRecord.record;
    },
    buyingInfo() {
      return {
        id: this.record.id,
        record_id: this.record.id,
        buying_info_status: this.record.buying_info_status,

        buying_analysis_id: this.record.buying_analysis_id,

        buying_info_accepted_at: this.record.buying_info_accepted_at,
        buying_info_closing_at: this.record.buying_info_closing_at,
        buying_info_contracted_at: this.record.buying_info_contracted_at,
      }
    },
    analysis() {
      return this.$store.state.activeRecord.fixAndFlipAnalysis;
    },
    worth() {
      if(this.analysis) {
        // these are null by default instead of 0 so the UI is easier to use, but for calculations I need them to be 0
        let afterRepairValue = this.analysis.after_repair_value ? this.analysis.after_repair_value : 0;
        let repairCosts = this.analysis.repair_costs ? this.analysis.repair_costs : 0;
        let otherCosts = this.analysis.other_costs ? this.analysis.other_costs : 0;
        let holdingCosts = this.analysis.holding_costs ? this.analysis.holding_costs : 0;
        let holdingTime = this.analysis.holding_time ? this.analysis.holding_time : 0;

        const holdingCostsCalculated = parseFloat(holdingCosts) * parseFloat(holdingTime);
        const totalCosts = parseFloat(repairCosts) + holdingCostsCalculated + parseFloat(otherCosts);

        return parseFloat(afterRepairValue) - totalCosts;
      } else {
        return 0;
      }
    },
    maxAllowableOffer() {
      if(this.analysis) {
        let desiredProfit = this.analysis.desired_profit ? this.analysis.desired_profit : 0;

        return this.worth - parseFloat(desiredProfit);
      } else {
        return 0;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

hr {
  margin: 0.75rem (-$modalGutter);
}
</style>
